const highlightSearch = (name, searchText) => {
    if (searchText.length > 0) {
        return name.replace(new RegExp(`(${searchText})`, 'i'), '<em>$1</em>');
    }

    return name;
};

export default highlightSearch;
